import { connect } from 'react-redux';

import { withdraw } from '../actions';
import Withdraw from './Withdraw';

const mapDispatchToProps = (dispatch, { campaignId, changeRequestId }) => ({
  onWithdraw: () => dispatch(withdraw(campaignId, changeRequestId)),
});

export default connect(null, mapDispatchToProps)(Withdraw);
